/**
 * groupPerson Normalizr Schema
 */

import { schema } from 'normalizr';

const groupPerson = new schema.Entity('groupPeople');

export default groupPerson;
